// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gray {
  color: #292727;
}

.admin-users-wrapper .results__header {
  font-weight: bold;
  text-align: center;
}
.admin-users-wrapper .results__row, .admin-users-wrapper .results__header {
  display: grid;
  grid-template-columns: 1fr 1fr 10rem 16rem;
  gap: 1rem;
  padding: 0.5rem;
}
.admin-users-wrapper .results__row > span, .admin-users-wrapper .results__header > span {
  text-overflow: ellipsis;
  width: 100%;
  overflow: hidden;
}
.admin-users-wrapper .results__row .user__subscribed,
.admin-users-wrapper .results__row .user__created, .admin-users-wrapper .results__header .user__subscribed,
.admin-users-wrapper .results__header .user__created {
  text-align: center;
}
.admin-users-wrapper .results__row:hover {
  background: rgba(0, 0, 0, 0.12);
}

.subscription-filter {
  display: flex;
  align-items: center;
}

.subscription-filter select {
  margin-left: 1rem;
}`, "",{"version":3,"sources":["webpack://./src/Styles/Colors.scss","webpack://./src/Components/Pages/Admin/AdminUsers/AdminUsers.scss"],"names":[],"mappings":"AAsCA;EACE,cArCU;ACAZ;;AAGI;EACE,iBAAA;EACA,kBAAA;AAAN;AAGI;EAEE,aAAA;EACA,0CAAA;EACA,SAAA;EACA,eAAA;AAFN;AAIM;EACE,uBAAA;EACA,WAAA;EACA,gBAAA;AAFR;AAKM;;;EAEE,kBAAA;AAFR;AAMI;EACE,+BAAA;AAJN;;AASA;EACE,aAAA;EACA,mBAAA;AANF;;AASA;EACE,iBAAA;AANF","sourcesContent":["// Define colors here to use across the site\n\n$textColor: #292727;\n$darkTextColor: #696969;\n$lightTextColor: #cacacb;\n$black: black;\n$borderColor: #c0c0c0;\n$gridBorderColor: #ddd;\n$hoverColor: #b8b8b8;\n$shadow: #9c9c9c;\n$gray: #efefef;\n$darkGray: #515554;\n$backgroundColor: #ffffff;\n$backgroundRight: #ffffff;\n$backgroundLeft: #e9e9e9;\n$success: #18b100;\n$headingsGray: #333333;\n$camelGold: #d0ad4d;\n$gold: #dabc64;\n$iconColor: #9c9c9c;\n$navIcon: #4d4d4d;\n$navIconActive: #dabc64;\n$iconColorActive: #dabc64;\n$magenta: #ab3a72;\n$habitPrimary: rgb(51, 51, 51);\n$habitBorder: rgb(208, 213, 221);\n$habitActionText: rgb(86, 86, 86);\n$habitActionIcon: #565656;\n\n// Brands\n$brand-primary: #3097d1;\n$brand-info: #8eb4cb;\n$brand-success: #2ab27b;\n$brand-warning: #cbb956;\n$brand-danger: red;\n\n$orange: #f5a000;\n\n.gray {\n  color: $textColor;\n}\n\n$input-color: #555;\n\n$headingColor: #999;\n$dayHeadingColor: #555;\n$undoBackground: #bdbdbd;\n","@import '~/Styles/Colors.scss';\n@import '~/Styles/Variables.scss';\n\n.admin-users-wrapper {\n  .results {\n    &__header {\n      font-weight: bold;\n      text-align: center;\n    }\n\n    &__row,\n    &__header {\n      display: grid;\n      grid-template-columns: 1fr 1fr 10rem 16rem;\n      gap: 1rem;\n      padding: 0.5rem;\n\n      & > span {\n        text-overflow: ellipsis;\n        width: 100%;\n        overflow: hidden;\n      }\n\n      .user__subscribed,\n      .user__created {\n        text-align: center;\n      }\n    }\n\n    &__row:hover {\n      background: rgba(0, 0, 0, 0.12);\n    }\n  }\n}\n\n.subscription-filter {\n  display: flex;\n  align-items: center;\n}\n\n.subscription-filter select {\n  margin-left: 1rem;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
